module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MN-35b571d3d8d0c187da3503d2ce626ffb.png";